import { Fragment } from "react";
import { useForm } from "react-hook-form";
import { Dialog, Transition } from "@headlessui/react";

//HOOKS
import useOnboarding from "../../hooks/useOnboarding";

//COMPONENTS
import Input from "../inputs/whiteText";
import Loading from "../loading/page";

export default function CoverModal() {
  const { isLoading, openModal, setOpenModal, submitEmail } = useOnboarding();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  if (isLoading) return <Loading />;
  return (
    <Transition.Root show={openModal} as={Fragment}>
      <Dialog as="div" className="relative z-[60]" onClose={setOpenModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden  bg-black px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full h-[100vh]  sm:p-6">
                <form
                  onSubmit={handleSubmit(submitEmail)}
                  className="max-w-4xl mx-auto flex flex-col items-center text-center justify-center h-full text-softWhite"
                >
                  <h1 className=" text-3xl lg:text-6xl font-header mb-8">
                    Want to make sure R&D projects get done on time?
                  </h1>
                  <p className="text-base lg:text-lg block my-2 text-gray-200 font-light font-copy max-w-3xl mx-auto">
                    Join <span className="font-bold">5,603 businesses</span>{" "}
                    already in our{" "}
                    <span className="font-bold">90 Day AI Challenge.</span> To
                    use Jackrabbit Ops to get{" "}
                    <span className="font-bold">
                      milestones completed on time.
                    </span>
                  </p>
                  <p className="text-base lg:text-lg block my-2 text-gray-200 font-light font-copy max-w-3xl mx-auto">
                    If after 90 days your team isn&apos;t shockingly productive
                    and happy{" "}
                    <span className="font-bold">
                      We will return every dollar you paid.
                    </span>
                  </p>

                  <div className="flex items-center space-x-2">
                    <div className="flex flex-shrink-0 -space-x-1 mt-4 mb-12">
                      {members.map((member) => (
                        <img
                          key={member.handle}
                          className="h-10 lg:h-12 2-10 lg:w-12 max-w-none rounded-full ring-2 ring-softWhite"
                          src={member.imageUrl}
                          alt={member.name}
                        />
                      ))}
                    </div>
                  </div>
                  <Input
                    title="Business Email"
                    name="email"
                    type="email"
                    placeholder="elon@spaceX.com"
                    register={register}
                    errors={errors.email}
                    white={true}
                  />

                  <div className="mt-8">
                    <button
                      type="submit"
                      className="text-lg lg:text-2xl bg-jackOrange text-white  hover:text-jackOrange w-full text-center relative px-7 py-3 border border-jackOrange  hover:bg-softWhite rounded-lg leading-none flex justify-center items-center divide-x divide-gray-600"
                    >
                      <span className="pb-[0.09rem] transition duration-200 ">
                        Yes, Please! &rarr;
                      </span>
                    </button>
                  </div>
                  <p
                    onClick={() => setOpenModal(false)}
                    className="underline font-thin text-base lg:text-lg mt-6 text-softWhite cursor-pointer hover:text-gray-500"
                  >
                    No, I like wasting time and money.
                  </p>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const members = [
  {
    name: "Dries Vincent",
    handle: "driesvincent",
    imageUrl:
      "https://images.unsplash.com/photo-1504199367641-aba8151af406?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Lindsay Walton",
    handle: "lindsaywalton",
    imageUrl:
      "https://images.unsplash.com/photo-1611873636366-cb3619248691?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Courtney Henry",
    handle: "courtneyhenry",
    imageUrl:
      "https://images.unsplash.com/photo-1548142542-c53707f8b05b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Tom Cook",
    handle: "tomcook",
    imageUrl:
      "https://images.unsplash.com/photo-1559637621-d766677659e8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Dries Vincent",
    handle: "driesvincenat",
    imageUrl:
      "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Lindsay Walton",
    handle: "lindsaywaltodn",
    imageUrl:
      "https://images.unsplash.com/photo-1614947897387-7896d478bb07?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Courtney Henry",
    handle: "courtneyhenfry",
    imageUrl:
      "https://images.unsplash.com/photo-1520529277867-dbf8c5e0b340?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    name: "Tom Cook",
    handle: "tomcookx",
    imageUrl:
      "https://images.unsplash.com/photo-1610069302033-6fee1f5791d2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
];
